import { render, staticRenderFns } from "./WidgetHistory.vue?vue&type=template&id=11e6dea9&scoped=true"
import script from "./WidgetHistory.vue?vue&type=script&lang=js"
export * from "./WidgetHistory.vue?vue&type=script&lang=js"
import style0 from "./WidgetHistory.vue?vue&type=style&index=0&id=11e6dea9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e6dea9",
  null
  
)

export default component.exports